import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch,Link,Redirect } from "react-router-dom";
import Preloader from 'components/preloader';
// import $ from 'jquery';
import 'assets/sass/main.scss';
import {getCookie} from 'utils/cookie';
import header from 'components/header'; 
import Footer from 'components/footer';
// import regnComp from 'components/registration/regnroutecomp';
// import loginroutehandler from 'components/loginroutehandler';
// import emailLinkHandler from 'components/emaillinkhandler';
import ComponentWrapper from 'components/componentwrapper';
import {initApp,initPortalSettings} from './appinitializer';
import dataService from 'utils/dataservice';
import Content from './components/content';
import {setLang,loadableComp,getCurrentPathWithQuery,setUserToken,resolveRouterPath} from 'utils/common';
import {setToCache,getFromCache,removeFromCache} from 'utils/querystring';
import {BEARER_KEY,SESSION_EXPIRED,LANG_SWITCHED,LANG, MENU_CLICKED , USER_SIGNIN, USER_SIGN_OUT, USER_TKEY, SHOW_LOGIN, PATH_PREFIX} from 'utils/constants';
import BoardingScreen from './components/boardingscreen/boardingscreen';
import 'assets/css/slick-carousel.css';
import Loader from 'components/loader';
// window.$ = $;
import HttpsRedirect from 'react-https-redirect';

const AUTO_SIGNIN = false;
initApp(AUTO_SIGNIN);
const Header = ComponentWrapper(header);
// const EmailLinkHandler = ComponentWrapper(emailLinkHandler);
// const LoginRouteHandler = ComponentWrapper(loginroutehandler);
// const RegnComp = ComponentWrapper(regnComp);
const LANGARR =['en','th'];
const ROUTES_LIST = [{ name:'export2', path:PATH_PREFIX+'export2', componentId:'emaillinkhandler'}]
class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {appinit:false, signedIn:false , userAuth:null, landingPageContent: {}};
        this.userSignIn = this.userSignIn.bind(this);
        this.userSignOut = this.userSignOut.bind(this);
        // this.autoSignOut = this.autoSignOut.bind(this);
        this.menuClicked = this.menuClicked.bind(this);      
        this.languageChanged = this.languageChanged.bind(this);    
        //this.disablePages = this.disablePages.bind(this);
        // const ev = {};
        // ev[MENU_CLICKED] = this.menuClicked;
        // ev[USER_SIGNIN] = this.userSignIn;
        // ev[USER_SIGN_OUT] = this.userSignOut;
        // ev[LANG_SWITCHED] = this.languageChanged; 
        app.events.subscribe({
            [MENU_CLICKED] : this.menuClicked,
            [USER_SIGNIN] : this.userSignIn,
            [USER_SIGN_OUT] : this.userSignOut,
            [LANG_SWITCHED] : this.languageChanged,
            [SESSION_EXPIRED] : this.userSignOut 
        });
        // }, this, -1);
        this.tokenCheck = process.env.TOKEN_CHECK== 'true';
        //this.loadPortalSettings();
        this.getUserInfo();
        // this.initLocation = location.origin+PATH_PREFIX;        
    }

    menuClicked([menuData]){
        //console.log('menu clicked');
        let url = resolveRouterPath(menuData["id"]);
        app.history.push(url);
    }

    // getLandingPageData(){
    //     let localeCode = getCookie(LANG) || 'en';
    //     dataService.getRequest(app.landingPage || 'landingPageData',{localeCode:localeCode}).then(res=>{
    //         if(res && res.landingPage)
    //         {
    //             this.setState({"landingPageContent": res.landingPage});
    //         }
    //     }).catch((error) => {
    //         console.log(error);
    //     });
    // }

    getUserInfo(){         
        if(getFromCache(USER_TKEY)){
            this.tokenCheck && dataService.getRequest('currentUserdata',{auth:true}).then(res=>{
                if(res && res.success){
                    let userdata = res.userdata;
                    let userAuth = {...(res.appAuthTokenTO || {}), ...userdata};
                    //userAuth.accessToken = userdata.accessToken;
                    //userAuth.accessToken = getFromCache(USER_TKEY);
                    // userAuth.authUserId = userdata.userId;
                    // userAuth.userId = res.supplierId;
                    //userAuth.supplierId = res.supplierId;
                    // userAuth.econtactId = res.econtactId;

                    app.events.trigger(USER_SIGNIN,userAuth,'renew');                    
                    this.loadPortalSettings();
                }
                else{
                    this.loadPortalSettings(true);
                } 
            })
            .catch((error) => {
                this.loadPortalSettings(true);
            });
            !this.tokenCheck && this.loadPortalSettings(true);
        }else {                       
            this.loadPortalSettings(true); 
           // app.events.trigger(SHOW_LOGIN, {signIn:true});
        }    
        ////TDO clr tokn from local whn eror    
        //if(AUTO_SIGNIN)document.body.classList.add('inner');
    }
    languageChanged([newLang]){
        //console.log('------language switched--------'+newLang);
        setLang(newLang);
        const history = app.history;
        app.history = null;
        const url = getCurrentPathWithQuery({lang:newLang});
        if(history){
            history.push(url);
        } else {
            location.reload();
        }
        app.events.unsubscribeUnMoutedCTx(true);
        this.setState({appinit:false});
        this.loadPortalSettings();
    }

    loadPortalSettings(clearCacheToken){     
        if(clearCacheToken) removeFromCache(USER_TKEY);     
        let pathname = location.pathname?location.pathname:'';
        let langPos = PATH_PREFIX.split('/').length - 1;
        let localeCode = null;//parsed from url
        if(pathname && pathname.indexOf(PATH_PREFIX) > -1){
            langPos = langPos + pathname.substr(0,pathname.indexOf(PATH_PREFIX)).split('/').length - 1;
            // console.log("lang from url. pathname: "+pathname+'--langPos'+langPos)
            localeCode = pathname.split('/')[langPos] || null;
            ////TODO temp fix;
            if(LANGARR.indexOf(localeCode) == -1) localeCode = null;
        }else{
            langPos = -1;
        }
        // console.log("localeCode: "+localeCode+'--cookie lang: '+getCookie(LANG))   
        // let localeCode = location.pathname? location.pathname.split('/')[2]:null;//parsed from url
        ///TODO//set and get LANG from app instead of getCookie
        localeCode = localeCode || getCookie(LANG);
        dataService.getRequest('portalSettings',{localeCode:localeCode}).then(res=>{
            initPortalSettings(res,localeCode, langPos);
            // this.getLandingPageData();
            this.setState({appinit:true});
        }).catch((err) => {
        });
    }

    userSignIn([userAuth,source]){        
        let d = new Date().getTime()-100;                    
        app.userAuth = userAuth;
        // app.userId = userAuth.authUserId;
        // 'login'==source && setToCache(USER_TKEY,userAuth.accessToken);
        //'renew'==source && 
        setUserToken(userAuth,true);
        // 'login'==source && setToCache(EXPIRES_AT,d+(userAuth.expiresAt*1000));
        let lang = getCookie(LANG);
        if('login'==source){
            //this.setUserToken(userAuth,true);
            // setToCache(LOGIN_USER_DATA,LOGIN_USER_DATA);
            if(lang && userAuth.preferredLanguage && lang !=userAuth.preferredLanguage){
                this.languageChanged([userAuth.preferredLanguage]);
            }
        }

        this.setState({signedIn:true });
        let isadminclass = app.userAuth.isAdmin ? 'admin':''; 
        document.body.classList.add('inner');
        if(isadminclass) document.body.classList.add(isadminclass);
        document.body.classList.remove('regn-step');
        //this.disablePages();
    }
    // setUserToken(userAuth,loginUser)
    // {
    //     setToCache(USER_TKEY,BEARER_KEY+userAuth.accessToken);
    //     //removeFromCache(LOGIN_USER_DATA);
    //     //loginUser && setToCache(LOGIN_USER_DATA,LOGIN_USER_DATA);
    // } 
    userSignOut(){ 
        !this.state.loggedout && this.setState({'loggedout':true}, function(){
            //gotoUrl(resolveRouterPath('login',{})); 
            dataService.getRequest('logout',{}).then(res=>{
                window.location.href = location.origin+PATH_PREFIX+'login';
            }).catch((error) => {
                //removeCookie(AUTH_KEY);
                window.location.href = location.origin+PATH_PREFIX+'login';
            });
        });
        //document.body.classList.remove('inner');

        
    
        // app.userAuth = null;
        // app.userId = null;
        ////removeFromCache(USER_TKEY);
        //this.setState({signedIn:false});
        //document.body.classList.remove('inner');
        // dataService.getRequest('logout',{}).then(res=>{
            //window.location.href = location.origin+PATH_PREFIX/login;
        // }).catch((error) => {
            //window.location.href = location.origin+PATH_PREFIX;
        // });        
    }     

    render () {
        if(!this.state.appinit)  return <Loader inline/>
        let isRegnPage = window.location.pathname.includes('/regn')
        return(
            <HttpsRedirect>
                <React.Fragment>
                    <Preloader/>
                    <Router> 
                        <Switch>
                            {ROUTES_LIST.map((route)=> {
                                let component = ComponentWrapper(loadableComp(route.componentId), route)
                                return <Route  {...route} key={route.name} component={component}/>
                            })}
                            {/* <Route exact path={PATH_PREFIX+'activate'} component={EmailLinkHandler}/>
                            <Route exact path={PATH_PREFIX+'resetpwd'} component={EmailLinkHandler}/>
                            <Route exact path={PATH_PREFIX+'login'} component={LoginRouteHandler}/>
                            <Route exact path={PATH_PREFIX+'regn'} component={RegnComp}/> */}
                            {/* <Route exact path={PATH_PREFIX+':lang/restpwd'} component={EmailLinkHandler}/> */}
                        </Switch>                        
                    </Router>
                    <Header pageQuery isRegnPage={isRegnPage} signedIn={this.state.signedIn} headerLinks={this.state.landingPageContent.section1}/>
                    {!isRegnPage && !this.state.signedIn && <BoardingScreen landingPageData ={this.state.landingPageContent}/>}
                    {!this.state.loggedout && this.state.signedIn && <Content />}
                    {this.state.loggedout && <div />}
                    {/* {!isRegnPage && <Footer signedIn={this.state.signedIn}/> }  */}
                </React.Fragment>
            </HttpsRedirect>
        )
    }
}

ReactDOM.render(<Main />, document.getElementById('approot'))
